import axios from '../../http/axios/index.js';

export default {
  /* eslint-disable */
  LOGIN_LOADING(state) {},
  LOGIN_SUCCESS(state) {},
  LOGIN_ERROR(state) {},
  SET_BEARER(state, accessToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
  },
};
